<template>
	<div class="staticpage">
		<div class="topImg">
			<img :src="img1" >
		</div>
		
		<div class="flex-swipe">
			<van-row>
			  <van-col span="1">
				  <img src="../../../assets/stage/icon8.png" >
			  </van-col>
			  <van-col span="19">
				  <van-swipe class="my-swipe" :autoplay="5000" vertical :loop="true" :height="26" :show-indicators="false">
				      <van-swipe-item><div class="jusaf">石**抢得靓号</div><div>157****4311</div></van-swipe-item>
				      <van-swipe-item><div  class="jusaf">张**抢得靓号</div><div>175****5633 </div></van-swipe-item>
				      <van-swipe-item><div class="jusaf">陈**抢得靓号</div><div>187****4321 </div></van-swipe-item>
				      <van-swipe-item><div class="jusaf">李**抢得靓号</div><div>181****3463 </div></van-swipe-item>
				      <van-swipe-item><div class="jusaf">王**抢得靓号</div><div>131****3429 </div></van-swipe-item>
				      <van-swipe-item><div class="jusaf">庄**抢得靓号</div><div>143****0975 </div></van-swipe-item>
				  </van-swipe>
			  </van-col>
			  <van-col span="4">仅剩<span style="color: #E02020;">29</span>张</van-col>
			</van-row>
		</div>
		<!-- <div class="only">仅限广东地区用户</div> -->
		<van-search v-model="value"  show-action  placeholder="请输入搜索尾号"  @search="onSearch" >
		  <template #action>
			<div @click="onClickButton">搜索</div>
		  </template>
		</van-search>
		<div class="phone_item">
			<van-row>
				 <van-col span="12" v-for="(item,index) in phoneList" :key="index"  @click="inputFocus(item)" >
					 <div class="col-bg">
						 <div class="phone_c">{{item}}</div>
						 <img src="../../../assets/stage/icon10.png" >
						 <div class="phone_flex">
						 	<div class="xe">68元</div>
							<div class="xe1">限时领取</div>
						 </div>
					 </div>
				 </van-col>
			</van-row>
		</div>
		<div class="search_btn">
			<div class="prevt"  @click="getLoad()">上一页</div>
			<div class="next"  @click="getLoad()">下一页</div>
		</div>
		<div class="bottomImg">
			<img :src="img2" >
		</div>
		
		<van-popup v-model:show="show" teleport="body" class="el-van-popup" round  position="bottom" closeable>
			<div class="sel">
				<span>已选择</span>
				<span style="color: #E02020;font-weight: 600;">靓号 {{dataFrom.phoneNum}}</span>
			</div>
			<div class="el-from">
				<van-form ref='form' >
					<div class="shrxx">收货人信息</div>
					<van-cell-group>
						<van-field required  v-model="dataFrom.takeNickname" error-message :rules="[ { required: true, message: '请填写您的姓名！' },{ pattern: /[\u4e00-\u9fa5]{2}/, message: '不能为数字、字母、特殊符号且不少于2个汉字！'}]" clearable class="name" label="姓名" placeholder="请输入收件人姓名" />
						<van-field required v-model="dataFrom.takePhone" maxlength="11" :rules="[ { required: true, message: '请填写您的联系电话！' },  { pattern: /^1[3456789]\d{9}$/, message: '联系电话格式错误！'} ]"clearable label="联系电话" placeholder="请输入11位联系电话" />
					</van-cell-group>
					<div class="shrxx">收货地址</div>
					<van-cell-group>
						<van-field required v-model="dataFrom.pcaAddress" :rules="[ { required: true, message: '请选择收货地址！' }]"  clearable label="收货地址" placeholder="请选择省市区" @focus="showAddressVisible()"/>
						<van-field required v-model="dataFrom.takeAddress"  :rules="[ { required: true, message: '请填写您的详细地址！' }]" clearable label="详细地址" placeholder="街道/小区/门牌号等" />
						<van-field required v-if="dataFrom.takeAddress.length>3" :rules="[{ required: true, message: '请填写身份证号' },{validator, message: '身份证号码格式错误！'}]" v-model="dataFrom.idCard" clearable label="身份证号" placeholder="请输入入网身份证号(已加密)" />
					</van-cell-group>
				</van-form>
				<van-popup v-model="dataFrom.addressVisible" position="bottom">
				    <van-area
				        :area-list="areaList"
                :columns-placeholder="['请选择', '请选择', '请选择']"
                @cancel="cancelSelectAddress()"
                @confirm="selectAddress"
				    />
				</van-popup>
				<div class="tip">根据国家实名制要求，请准确提供身份证信息</div>
				<div class="checkbox-info">
					<van-button round type="info" class="btnButton" @click="sunmbitFn()">立即领取  包邮到家</van-button>
					<van-row>
						<van-col span="2">
							<van-checkbox v-model="checked"></van-checkbox> 
						</van-col>
						<van-col span="22">
							<span style="cursor: pointer;" @click="aaaa()">已阅读并同意</span><span style="color:#E02020;cursor: pointer;line-height: 22px;" @click="aaaa()">《客户入网服务协议及业务协议》
《信息收集公告》</span>
						</van-col>
					</van-row>
				</div>
			</div>
		</van-popup>


		<!--弹窗-->
		<div class="tanchuang" v-if="hidden==true">
			<div class="tanchuangclose"></div>
			<div class="tanchuangs">
				<div style="width: 100%;height: 100%;display: flex;flex-direction: column;align-items: center;justify-content: center;position: relative;">
					<img src="../../../assets/lianghao.png" alt="" style="width: 95%;">
					<div @click="tiaozhuan" 
					style="width: 200px;height: 50px;position: absolute;top: 51%;"
					></div>
					<div style="width: 50px;height: 50px;position: absolute;top: 66%;" @click="hidden=false"></div>
				</div>
			</div>
		</div>
		<!--弹窗-->
	</div>
</template>
 <script type="text/javascript">(function (root) {    var ksscript = document.createElement('script');    ksscript.setAttribute('charset', 'utf-8');    ksscript.src = '//p2-yx.adkwai.com/udata/pkg/ks-ad-trace-sdk/ks-trace.3.2.0.min.js';    var s = document.getElementsByTagName('script')[0];    s.parentNode.insertBefore(ksscript, s);})(window);</script>
<script>
	import { wxRequest } from '@/api/user'
	import areaListData from "@/utils/Area.js";
	import { Toast } from 'vant';
	export default{
		data(){
			return{
				img1:'',
				img2:'',
				value:'',
				dataList:[
					{goodsId:'512204287700',productId:'91215645',imgUrl:'icon4.png',activeImgUrl:'icon7.png'},
					{goodsId:'512204287698',productId:'91215646',imgUrl:'icon6.png',activeImgUrl:'icon2.png'},
					{goodsId:'512204287696',productId:'91215644',imgUrl:'icon3.png',activeImgUrl:'icon5.png'}
				],
				checked:true,
				show:false,
				time: 20 * 30 * 1000,
				dataFrom:{
					others:'111',
				   takeNickname:'' ,
				   provinceCode:'',
				   cityCode:'',
				   goodsId:"512204287698",
				   baseProductId:'91215646',
				   postDistrictCode:'',
				   addressVisible:false,
				   takePhone:'',
				   phoneNum:'',
				   takeAddress:'',
				   changeCmccSim:'1',
				   pcaAddress:'',
				},
				phoneList:[],
				provinceList:[],
				countyList:[],
				cityList:[],
				  hidden:false,
				areaList:areaListData,
			}
		},
		created(){
			let urls= window.location.href;
            this.dataFrom.agentId= this.$route.query.agentId;
            var data={
              agentId: this.dataFrom.agentId
            }
         wxRequest('applyChangeSim/apply/sim/info',data, 'post').then(res => {
                if(res.data.code == 200){
                    this.img1= process.env.VUE_APP_IMG_URL + '/' + res.data.data.shopImgss;
                    console.log(this.headUrl)
                    this.img2= process.env.VUE_APP_IMG_URL + '/' +res.data.data.shopHeadImgs;
                  
                }else {
                    Toast.fail(res.data.message);
                    return;
                }
            })
			
			this.getLoad()
		},
		  mounted(){
		//监听浏览器返回
		if (window.history && window.history.pushState) {
		history.pushState(null, null, document.URL);
		
		window.addEventListener('popstate', this.goBack, false);
		
		}

    },
		methods:{

			  destroyed(){
		   window.removeEventListener('popstate', this.goBack, false);
		},
          ScrollUp2() {
           var parent = document.getElementById('list-content');
            var child1 = document.getElementById('detetion-con1');
            var child2 = document.getElementById('child2');
            child2.innerHTML = child1.innerHTML; // 无缝衔接
            setInterval(function () {
               if(parent.scrollTop >= child1.scrollHeight) {
                   parent.scrollTop = 0;
               } else {
                   parent.scrollTop++;
               }

            },100);
        },
        tiaozhuan(){
			this.$router.push('/user/applygdtdouyingMy');
		},
		goBack(){
            
            var data={
               
            }
            if(this.dataFrom.takePhone!=""&&this.dataFrom.takePhone!=''&&this.dataFrom.takePhone!=null){
                data.takePhone=this.dataFrom.takePhone;
            }
			 wxRequest("applyChangeSim/apply/is/have", data, "post").then(res => {
                if(res.data.code == 200){
                      //this.show=false;
                     // this.hidden = true;
			          
                }
            })

		},
			 /**
			 * 身份证验证
			 */
			validator (val) {
			  const card15 = /^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/
			  const card18 = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
			  return card15.test(val) || card18.test(val)
			},
			setKeyAndValue(key,value){
				var obj = {};
				obj[key]=value
				this.areaList.province_list={...obj,...this.areaList.province_list}
			},
			setKeyAndCityValue(key,value){
				var obj = {};
				obj[key]=value
				this.areaList.city_list={...obj,...this.areaList.city_list}
				this.$forceUpdate()
				console.log(this.areaList)
			},
			setKeyAndCountyValue(key,value){
				var obj = {};
				obj[key]=value
				this.areaList.county_list={...obj,...this.areaList.county_list}
				this.$forceUpdate()
			},
			changeGoogs(item){
				this.dataFrom.goodsId = item.goodsId
				this.dataFrom.baseProductId = item.productId
				wxRequest('/applyChangeSim/default/info', {goodsId:item.goodsId}, 'post').then(res => {
				    if(res.data.code == 200){
				        this.dataFrom.phoneNum = res.data.data.phone
				    }else {
				        Toast.fail(res.data.message);
				    }
				})
				this.getLoad()
			},
			areaChange(vale,data,rowIndex){
				var pid = data[rowIndex].code
				if(rowIndex===0){
					this.$set(this.areaList,'city_list',{})
				}else if(rowIndex === 1){
					this.$set(this.areaList,'county_list',{})
				}
				wxRequest('/applyChangeSim/apply/address', {pid:pid}, 'post').then(res => {
				    if(res.data.code == 200){
						res.data.data.forEach(item=>{
							for (let i in item) {
								if(rowIndex===0){
									if(i === 'codes'){
										this.cityList = res.data.data
										this.setKeyAndCityValue(item[i],item.name);
									}
								}else if(rowIndex === 1){
									this.countyList = res.data.data
									if(i === 'codes'){
										this.setKeyAndCountyValue(item[i],item.name);
									}
								}
							}
						})
				    }else {
				        Toast.fail(res.data.message);
				    }
				})
			},
			selectAddress(values) {
			    if (!values[0].code || values[0].code.length < 1) {
			        Toast.fail("请选择地区");
			        return;
			    }
			
			    if (!values[1].code || values[1].code.length < 1) {
			        Toast.fail("请选择地区");
			        return;
			    }
			
			    if (!values[2].code || values[2].code.length < 1) {
			        Toast.fail("请选择地区");
			        return;
			    }
				this.dataFrom.provinceCode = values[0].code
				this.dataFrom.cityCode = values[1].code
				this.dataFrom.postDistrictCode = values[2].code
				this.dataFrom.pcaAddress = values[0].name +'-'+ values[1].name +'-'+ values[2].name;
			    this.dataFrom.addressVisible = false;
			},
			cancelSelectAddress() {
			    this.dataFrom.pcaAddress = "";
			    this.dataFrom.addressVisible = false;
			},
			showAddressVisible() {
			    this.dataFrom.addressVisible = true;
			},
			inputFocus(data){
				this.show = true
				this.dataFrom.phoneNum = data
				// this.getLoad()
			},
			phoneChenk(item){
				this.show = false
				this.dataFrom.phoneNum = item
			},
			getLoad(){
				this.phoneList = []
				var params = {
					goodsId:this.dataFrom.goodsId,
					searchValue:this.value
				}
				wxRequest('/applyChangeSim/apply/phones', params, 'post').then(res => {
				    if(res.data.code == 200){
				       this.phoneList = res.data.data
				    }else {
				        Toast.fail(res.data.message);
				    }
				})
				
			},
			onSearch(){
				if(this.value.length !== 0 && this.value.length !== 4 ){
					Toast.fail('搜索提交只能4位数字');
					return
				}
				this.getLoad()
			},
			onClickButton(){
				if(this.value.length !== 0 && this.value.length !== 4 ){
					Toast.fail('搜索提交只能4位数字');
					return
				}
				this.getLoad()
			},
			// 提交数据
			sunmbitFn(){
				this.$refs.form.validate().then((res) => {
					var parmas = {
						...this.dataFrom
					}
					console.log(parmas)
					wxRequest('/applyChangeSim/apply/sim/add',parmas, 'post').then(res => {
					    if(res.data.code == 200){
							this.show=false;
					       Toast.fail('提交成功');
					    }else {
					        Toast.fail(res.data.message);
					    }
					})
					
				},(res)=>{
					    Toast.fail('请填写正确参数！');
				});
			}
		}
	}
</script>

<style lang="less" scoped>
	.staticpage{
		max-width:540px;
		margin: 0 auto;
		// height: 100%;
		background: #1c1b19;
		.flex_item{
			width:98%;
			margin: 5px auto 20px auto;
			// background:#fff;
			.van-col--8{
				height:66px;
				text-align: center;
				img{
					height:100%;
				}
			}
		}
		.flex-swipe{
			width:92%;
			margin: 0 auto;
			.van-col--1{
				line-height:25px;
				img{
					height:12px;
				}
			}
			.van-col--19{
				// display:flex;
				padding-left: 40px;
				.my-swipe{
					color: #FFFFFF;
					width:100%;
				    height: 25px; 
				    line-height:25px;
					.van-swipe-item{
						width:100%;
					}
					div{
						font-size:12px;
						display: inline-block;
					}
					.jusaf{
						width:55%;
					}
				}
			}
			.van-col--4{
				line-height:25px;
				color:#fff;
				text-align: right;
				font-size:12px;
			}
		}
		.only{
			width:95%;
			margin: 20px auto 11px auto;
			color: #E02020;
			font-weight: 600;
			font-size:14px;
		}
		.van-search{
			background: none;
			position: relative;
			padding-right:12px;
			.van-search__content{
				background: none;
				border:1px solid #FDE0C4;
				border-radius:21px;
				height:38px;
				line-height:38px;
				.van-cell--borderless{
					line-height:26px;
					::v-deep .van-field__control{
						color:#fff;
					}	
				}
				::v-deep .van-icon-search{
					color:#FDE0C4;
				}
			}
			.van-search__action{
				position: absolute;
				right:12px;
				width:66px;
				border-radius: 21px;
				text-align: center;
				background: #FDE0C4;
				line-height:38px;
				height:38px;
			}
		}
		.phone_item{
			width:95%;
			margin: 18px auto;
			.van-col--12{
				padding:0 6px 18px 6px;
				.col-bg{
					background:#fff;
					padding:10px 10px;
					border-radius:16px ;
					position:relative;
					.phone_c{
						color:#000000;
						font-size:16px;
						font-weight: 600;
						line-height: 22px;
					}
					img{
						width:27px;
						position: absolute;
						right:0;
						top:-8px;
					}
					.phone_flex{
						display: flex;
						margin-top: 8px;
						.xe{
							flex: 1;
							text-align: left;
							color: #9D9D9D;
							font-size:14px;
							font-weight: 400;
							text-decoration:line-through;
						}
						.xe1{
							flex: 1;
							text-align: left;
							color: #E02020;
							font-size:14px;
							font-weight: 400;
						}
					}
				}
			}
		}
		.search_btn{
			width:95%;
			margin:3px auto 26px auto;
			display: flex;
			div{
				width: 124px;
				height:38px;
				line-height:38px;
				margin:0 auto;
				text-align: center;
				border-radius:21px;
				background: #FDE0C4;
				font-size: 14px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #000000;
			}
		}
		.el-from{
			padding: 10px;
			width:90%;
			background:#fff;
			border-radius: 16px;
			margin: 0 auto;
			.shrxx{
				margin-top:21px;
				color:#000;
				font-size:16px;
				font-weight:500;
				background: url(../../../assets/stage/icon15.png) no-repeat left bottom;
				background-size: 76px 5px;
				font-family: PingFangSC-Medium, PingFang SC;
				margin-bottom: 24px;
			}
			.van-cell-group{
				border-bottom: 1px solid #ebedf0;
			    &::after{
			        border:none
			    }
				.name{
					::v-deep .van-cell__title{
						letter-spacing:28px;
					}
				}
				.van-field{
					padding:10px 0px;
					&::after{
					   left:0;
					}
					&::before{
						left:56px;
					}
				}
				::v-deep.van-cell__value{
					.van-field__control{
						line-height:22px;
					}
				}
				::v-deep .disbaled{
					.van-cell__value{
						background: url(../../../assets/stage/icon9.png) no-repeat right center;
						background-size:9px 14px;
						position:relative;
						&::after{
							content: '可自选';
							position: absolute;
							z-index: 9;
							color:#999;
							right: 18px;
							top: 0px;
						}
					}
				}
			}
			.btnButton{
			    width:100%;
			    margin: 10px auto;
			    display: block;
				height:46px;
			    background:#E02020;
			    border:1px solid #E02020;
			    cursor: pointer;
			    font-size:18px;
			}
			.btnButton{
			    -webkit-animation: free_download 1s linear alternate infinite;
			    animation: free_download 1s linear alternate infinite;
			}
			@-webkit-keyframes free_download{
			    0%{-webkit-transform:scale(0.9);}
			    100%{-webkit-transform:scale(1);}
			}
			@keyframes free_download{
			    0%{transform:scale(0.9);}
			    100%{transform:scale(1);}
			}
			.checkbox-info{
			    width: 93%;
			    margin: 10px auto;
			    font-size:12px;
			    // color:#fff;
			    .van-checkbox{
			        display: inline-block;
			        vertical-align: middle;
			        margin-right:10px;
			    }
			}
			.tip{
				color: #999999;
				text-align: center;
				margin: 0 auto;
				margin-top: 10px;
				margin-bottom:20px;
				line-height:18px;
				width:240px;
				font-size:12px;
			}
		}
		.topImg img,.bottomImg img{
		    width:100%;
		    height:100%;
		}
		.el-van-popup{
			width:100%;
			::v-deep .van-popup__close-icon--top-right{
				font-size:14px;
			}
			.sel{
				color:14px;
				margin-top:20px;
				margin-left: 21px;
				span{
					display:inline-block;
					padding-right: 12px;
				}
			}
			.top_tip{
				color:#d74a49;
				.van-col--16{
					line-height:22px;
				}
				.van-col--8{
					text-align: right;
					.colon {
						display: inline-block;
						margin: 0 4px;
						color: #ee0a24;
					}
					.block {
						display: inline-block;
						width: 22px;
						color: #fff;
						font-size: 12px;
						text-align: center;
						background-color: #ee0a24;
					}
				}
			}
			::v-deep .van-search--show-action{
				background:#f5f5f5 !important;
				margin-top:15px;
				.van-search__content{
					background: #fbfbfb;
				}
			}
			::v-deep .van-field__control{
				line-height:22px;
			}
			.phone_content{
				border:1px solid #dedede;
				margin-top:18px;
				padding: 10px;
				.phone_gif{
					margin-bottom:10px;
					text-align: center;
					img{
						width:204px;
					}
				}
				.phone-item{
					.van-col--12{
						font-size:14px;
						text-align: center;
						margin-bottom:8px;
					}
				}
			}
			.change_batch{
				font-weight:bold;
				cursor: pointer;
				font-size:16px;
				color: #e6cc92;
				text-align: center;
				margin-top:14px;
				margin-bottom:18px;
			}
		}
	}
</style>
